// extracted by mini-css-extract-plugin
module.exports = {"root":"rUXkCQ","title":"fAff7Y"};